"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { ChangeEvent, Suspense, useTransition } from "react";

type Props = { paramName: string };

function Filter({ paramName }: Props) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const cnt = searchParams.get(paramName);
  const b = cnt?.substring(0, 1);
  const s = cnt?.substring(1, 2);
  const o = cnt?.substring(2, 3);
  const [isPending, startTransition] = useTransition();

  const handle = (e: ChangeEvent<HTMLInputElement>) => {
    const params = new URLSearchParams(searchParams.toString());
    if (!cnt || !b) {
      if (e.target.name === "b") params.set(paramName, `${e.target.value}99`);
      else if (e.target.name === "s") params.set(paramName, `9${e.target.value}9`);
      else if (e.target.name === "o") params.set(paramName, `99${e.target.value}`);
      else params.set(paramName, `999`);
    } else {
      if (e.target.name === "b") params.set(paramName, e.target.value + s + o);
      else if (e.target.name === "s") params.set(paramName, b + e.target.value + o);
      else if (e.target.name === "o") params.set(paramName, b + s + e.target.value);
      else params.set(paramName, `999`);
    }
    router.replace("?" + params.toString(), { scroll: false });
  };
  const handleClear = (name: string) => {
    startTransition(() => {
      const params = new URLSearchParams(searchParams.toString());
      if (cnt && b) {
        if (name === "b") params.set(paramName, "9" + s + o);
        else if (name === "s") params.set(paramName, b + "9" + o);
        else if (name === "o") params.set(paramName, b + s + "9");
        else params.set(paramName, `999`);
      }

      if (params.get(paramName) === "999") params.delete(paramName);
      router.replace("?" + params.toString(), { scroll: false });
    });
  };

  const InputComponents = ({
    cntVal,
    cntName,
    loop,
    color,
  }: {
    cntVal: string | undefined;
    cntName: string;
    loop: number;
    color: string;
  }) => {
    return (
      <div className="grid grid-cols-2 gap-3">
        <div className="rating rating-sm flex items-center text-center">
          <div className="w-3 bg-transparent">{cntName.toUpperCase()}</div>
          <input
            type="radio"
            name={cntName}
            value="0"
            className="mask mask-circle bg-gray-500/30 aria-checked:bg-gray-500/30"
            checked={cntVal === "9" || cntVal === "0"}
            onChange={handle}
          />
          {[...Array(loop)].map((_, i) => (
            <input
              key={i}
              type="radio"
              name={cntName}
              value={String(i + 1)}
              className={`mask mask-circle ${color}`}
              checked={cntVal === String(i + 1)}
              onChange={handle}
            />
          ))}
        </div>
        <div
          className={`${(cnt && cntVal !== "9") || "invisible"} ${
            isPending && "skeleton"
          } border border-secondary rounded-md hover:bg-secondary text-center`}
          onClick={() => handleClear(cntName)}
        >
          Clear
        </div>
      </div>
    );
  };

  return (
    <div className="grid grid-rows-3 mx-2 items-center">
      <InputComponents cntName="b" cntVal={b} loop={3} color="bg-green-400" />
      <InputComponents cntName="s" cntVal={s} loop={2} color="bg-yellow-400" />
      <InputComponents cntName="o" cntVal={o} loop={2} color="bg-red-400" />
    </div>
  );
}
export default function CntFilter(props: Props) {
  return (
    <Suspense
      fallback={
        <div className="grid grid-rows-3 mx-2 items-center">
          <div></div>
          <div></div>
          <div></div>
        </div>
      }
    >
      <Filter {...props} />
    </Suspense>
  );
}
